<template>
  <div>
    <div class="banner">
      <img :src="banner" v-if="clientWidth > 768" alt="" />
      <img :src="banner_m" v-if="clientWidth <= 768" alt="" />
    </div>

    <div class="module drawContent">
      <div class="wrap">
        <div class="draw-title">
          <img class="side-icon" :src="imgs.sideIcon" alt="" />
          <div class="title-text">每日幸运抽奖</div>
          <img class="side-icon side-icon-right" :src="imgs.sideIcon" alt="" />
        </div>

        <div class="wheel-stage">
          <div class="wheel-box">
            <div class="wheel-ring" :style="{ transform: 'rotate(' + rotateDeg + 'deg)' }">
              <div class="wheel-face">
                <img class="wheel" :src="imgs.luckyWheel" alt="幸运大转盘" />
                <div class="wheel-prizes" v-if="wheelPrizes.length">
                  <div class="wheel-prize" v-for="(item, index) in wheelPrizes" :key="item.PrizeId || index"
                    :style="prizeStyle(index)">
                    <div class="wheel-prize-inner">
                      <p class="wheel-prize-name">{{ item.PrizeName }}</p>
                      <img class="wheel-prize-img" :class="'wheel-prize-img-' + index" :src="item.ImageUrl" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <img class="pointer" :src="imgs.pointer" alt="GO" @click="handleGo"
              v-ga="{ event: 'draws', ec: 'lottery', ea: 'godraws', el: 'godraws' }" />
          </div>
          <img class="tray" :src="imgs.tray" alt="" />
        </div>

        <div class="draw-actions">
          <div class="draw-btn remain">
            <img class="btn-icon flower" :src="imgs.icon02" alt="" />
            <span class="btn-label">今日剩余次数</span>
            <span class="btn-count">{{ remainCount }}</span>
          </div>
          <div class="draw-btn prize" @click="openPrizeList"
            v-ga="{ event: 'draws', ec: 'lottery', ea: 'myprize', el: 'myprize' }">
            <img class="btn-icon gift" :src="imgs.icon01" alt="" />
            <span class="btn-label">我的奖品</span>
            <img class="btn-arrow" :src="imgs.arrowIcon" alt="" />
          </div>
        </div>
      </div>
    </div>

    <div class="draw-dialog" v-if="dialogVisible">
      <div class="draw-dialog-mask"></div>
      <div class="draw-dialog-card" :class="'type-' + dialogType" @click.stop>
        <div class="dialog-header" :class="{ 'is-list': dialogType === 'list' }">
          <img class="header-bg" :src="dialogType === 'list' ? imgs.listBg : imgs.prizeBg" alt="" />
          <img class="header-logo" v-if="dialogType !== 'list'" :src="logo" alt="Schneider" />
          <div class="header-title" v-else>我的奖品</div>
          <img class="header-close" :src="imgs.closeIcon" alt="关闭" @click="closeDialog"
            v-ga="{ event: 'draws', ec: 'lottery', ea: 'close', el: 'close' }" />
        </div>

        <!-- 中奖 -->
        <div class="dialog-body win-body" v-if="dialogType === 'win'">
          <img class="prize-img" :src="currentPrize.img" alt="" />
          <p class="win-text">恭喜您！抽中{{ currentPrize.level }}</p>
          <p class="win-name">{{ currentPrize.name }}</p>
          <button v-if="currentPrize.prizeType === 2" class="dialog-btn" type="button" @click="goToForm"
            v-ga="{ event: 'draws', ec: 'lottery', ea: 'claim', el: 'claimok' }">立即领取</button>
          <button v-else class="dialog-btn" type="button" @click="closeDialog"
            v-ga="{ event: 'draws', ec: 'lottery', ea: 'back', el: 'win' }">返回</button>
        </div>

        <!-- 填写领奖信息 -->
        <div class="dialog-body form-body" v-if="dialogType === 'form'">
          <div class="form-title">填写领奖信息</div>
          <div class="form-item">
            <label>收件人 <i>*</i></label>
            <input v-model="prizeForm.name" type="text" maxlength="50" placeholder="请输入收件人姓名" />
          </div>
          <div class="form-item">
            <label>电话 <i>*</i></label>
            <input v-model="prizeForm.phone" type="text" maxlength="30" placeholder="请输入联系电话" />
          </div>
          <div class="form-item">
            <label>收件地址 <i>*</i></label>
            <input v-model="prizeForm.address" type="text" maxlength="300" placeholder="请输入详细收件地址" />
          </div>
          <div class="form-btns">
            <button class="dialog-btn ghost" type="button" @click="backFromForm"
              v-ga="{ event: 'draws', ec: 'lottery', ea: 'back', el: 'win' }">返回</button>
            <button class="dialog-btn" type="button" @click="submitPrizeForm"
              v-ga="{ event: 'draws', ec: 'lottery', ea: 'redeemok', el: 'redeemok' }">确认兑换</button>
          </div>
        </div>

        <!-- 兑换成功 -->
        <div class="dialog-body success-body" v-if="dialogType === 'success'">
          <img class="success-img" :src="imgs.success" alt="" />
          <p class="success-text">兑换成功</p>
          <button class="dialog-btn" type="button" @click="closeDialog"
            v-ga="{ event: 'draws', ec: 'lottery', ea: 'back', el: 'success' }">返回</button>
        </div>

        <!-- 我的奖品 -->
        <div class="dialog-body list-body" v-if="dialogType === 'list'">
          <div class="prize-grid" v-if="myPrizes.length">
            <div class="prize-card" v-for="(item, index) in myPrizes" :key="item.drawId || index">
              <span class="prize-tag" :class="item.status">
                <i v-if="item.status === 'done'">✓</i>{{ item.status === 'done' ? '已兑换' : '未兑换' }}
              </span>
              <div class="prize-visual">
                <span class="prize-dot"></span>
                <div class="prize-circle">
                  <img class="prize-card-img" :src="item.img" alt="" />
                </div>
              </div>
              <p class="prize-card-name">{{ item.name }}</p>
              <p class="prize-card-time">中奖时间：{{ item.time }}</p>
              <div class="prize-card-foot">
                <button class="redeem-btn" type="button" @click="goToRedeem(item)"
                  v-ga="{ event: 'draws', ec: 'lottery', ea: 'redeem', el: item.status === 'done' ? 'edit' : 'go' }">
                  {{ item.status === 'done' ? '修改地址' : '去兑换' }}
                </button>
              </div>
              <!-- <div class="prize-card-foot">
                <button
                  v-if="item.status !== 'done'"
                  class="redeem-btn"
                  type="button"
                  @click="goToRedeem(item)"
                >去兑换</button>
                <p class="prize-card-time" v-else>中奖时间：{{ item.time }}</p>
              </div> -->
            </div>
          </div>
          <div class="prize-empty" v-else>暂无奖品</div>
        </div>

        <!-- 未中奖 -->
        <div class="dialog-body lose-body" v-if="dialogType === 'lose'">
          <img class="prize-img lose-img" :src="imgs.prize07" alt="" />
          <p class="lose-text">很遗憾，您未中奖</p>
          <button class="dialog-btn" type="button" @click="closeDialog"
            v-ga="{ event: 'trk', ec: 'lottery', ea: 'back', el: 'lose' }">返回</button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>


import { UserIntegralInfo } from "../../api/index.js";
import { setCookie, removeCookie } from "../../utils/_handleCookie";
import { GetUserLogs, AddPoints, GetActivityInfo, LotteryDraw, GetMyPrizes, SaveShippingInfo } from "@/api/index.js";
import { Res_Url, Res_Url2026 } from "@/utils/ApiToken.js";
export default {
  data() {
    return {
      banner: Res_Url2026 + "/common/photo_banner.png",
      banner_m: Res_Url2026 + "/common/photo_banner_m.png",
      logo: Res_Url2026 + "/logo.png",
      loginChecked: false, // 登录态是否已处理过，避免 islogin 反复触发拉接口
      activityReady: false, // GetActivityInfo 是否已成功，未完成前不允许点抽奖
      activityInfoReqId: 0, // 活动信息请求序号，用于丢弃过期回包，避免覆盖抽奖后的次数
      remainCount: 0, // 今日剩余抽奖次数
      activityStatus: "", // 本地计算的活动状态：NotStarted / DailyClosed / Open / Closed
      pointsPerDraw: 0, // 每次抽奖消耗积分
      currentPoints: 0, // 当前积分
      activityPrizes: [], // 转盘奖品列表
      activityStartDate: "", // 活动开始日期 StartDate
      activityEndDate: "", // 活动结束日期 EndDate（按日期包含当天）
      dailyStartTime: "", // 每天开放抽奖开始时间 HH:mm:ss
      dailyEndTime: "", // 每天开放抽奖结束时间 HH:mm:ss
      clockOffset: 0, // 服务器时间与本地时间的差值（毫秒），用于校准用户手机时钟
      statusTimer: null, // 下一状态切换定时器（到点更新 UI，不轮询接口）
      dialogVisible: false,
      dialogType: "win",
      submitting: false,//是否提交中
      currentPrize: {
        drawId: "",
        prizeId: "",
        prizeType: 0,
        name: "",
        level: "",
        img: "",
      },
      prizeForm: {
        name: "",
        phone: "",
        address: "",
      },
      formBackTo: "win",
      myPrizes: [],//我的奖品
      rotateDeg: 0,
      spinning: false,
      wheelPhase: "idle",
      wheelRaf: null,
      wheelSpeed: 0,
      wheelLastTs: 0,
      wheelMinSpeed: 90,
      wheelMaxSpeed: 1080,
      wheelAccelTime: 1400,
      wheelDecelTime: 2800,
      wheelAccelElapsed: 0,
      wheelDecelElapsed: 0,
      wheelDecelStartDeg: 0,
      wheelDecelDistance: 0,
      wheelStartResolve: null,
      wheelStopResolve: null,
      imgs: {
        luckyWheel: Res_Url2026 + "/draw/luckyWheel.png",
        pointer: Res_Url2026 + "/draw/pointer.png",
        tray: Res_Url2026 + "/draw/tray.png",
        icon01: Res_Url2026 + "/draw/Icon01.png",
        icon02: Res_Url2026 + "/draw/Icon02.png",
        arrowIcon: Res_Url2026 + "/draw/arrowIcon.png",
        sideIcon: Res_Url2026 + "/draw/sideIcon.png",
        prizeBg: Res_Url2026 + "/draw/prize_bg.png",
        listBg: Res_Url2026 + "/draw/list_bg.png",
        closeIcon: Res_Url2026 + "/draw/closeIcon.png",
        success: Res_Url2026 + "/draw/success.png",
        prize07: Res_Url2026 + "/draw/prize07.png",
      },
    };
  },
  components: {},
  mounted() {
    // 切回前台时重新拉活动信息，对齐次数/积分/开关窗
    document.addEventListener("visibilitychange", this.onVisibilityChange);
    GetUserLogs({
      visitName: "页面访问-每日幸运抽奖",
      visitType: 1,
      url: window.location.href,
      track: this.$route.query.track ? this.$route.query.track : 11058,
    });
  },
  watch: {
    // 进入抽奖页且登录态就绪后，拉一次活动信息
    islogin: {
      immediate: true,
      handler(val) {
        if (val === null || this.loginChecked) return;
        this.loginChecked = true;
        if (val) {
          this.getActivityInfo();
        } else {
          this.toLogin();
          return;
          // this.$toast({ message: "未登录" });
        }
      },
    },
  },
  methods: {
    toLogin() {
      if (!this.$store.state.islogin) {
        let params = this.$route.query;
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        let querys;
        querys = {
          backlink: encodeURIComponent(window.location.href),
          track: params.track ? params.track : "",
          utm_source: params.utm_source ? params.utm_source : "",
          utm_medium: params.utm_medium ? params.utm_medium : "",
          utm_campaign: params.utm_campaign ? params.utm_campaign : "",
          utm_content: params.utm_content ? params.utm_content : "",
          se_sr: params.se_sr ? params.se_sr : "",
          se_md: params.se_md ? params.se_md : "",
          se_ct: params.se_ct ? params.se_ct : "",
        };
        this.$router.push({
          name: "Register",
          query: querys,
        });
      }
    },
    // 页面从后台回到前台：重新拉取活动信息
    onVisibilityChange() {
      if (document.visibilityState !== "visible") return;
      if (!this.islogin) return;
      this.getActivityInfo();
    },
    // 校准后的当前时间，不直接使用用户手机时间
    getNowMoment() {
      return this.$moment(Date.now() + this.clockOffset);
    },
    // 解析接口返回的日期时间，优先按 YYYY-MM-DD HH:mm:ss（兼容 iOS）
    parseDateTime(value) {
      if (!value) return this.$moment.invalid();
      const parsed = this.$moment(value, "YYYY-MM-DD HH:mm:ss", true);
      return parsed.isValid() ? parsed : this.$moment(value);
    },
    // 用接口 ServerTime 计算与本地时钟的偏移
    applyServerTime(serverTime) {
      const ts = this.parseDateTime(serverTime);
      this.clockOffset = ts.isValid() ? ts.valueOf() - Date.now() : 0;
    },
    // 按活动日期 + 每日时段本地计算状态，避免死盯进页时的 ActivityStatus 快照
    // NotStarted=未开始，DailyClosed=当天未开放，Open=可抽，Closed=已结束
    computeActivityStatus() {
      if (!this.activityStartDate || !this.activityEndDate || !this.dailyStartTime || !this.dailyEndTime) {
        return this.activityStatus || "";
      }
      const now = this.getNowMoment();
      const start = this.parseDateTime(this.activityStartDate);
      if (!now.isValid() || !start.isValid()) return this.activityStatus || "";
      if (now.isBefore(start)) return "NotStarted";
      const nowDay = now.format("YYYY-MM-DD");
      const endDay = this.parseDateTime(this.activityEndDate).format("YYYY-MM-DD");
      if (nowDay > endDay) return "Closed";
      const nowTime = now.format("HH:mm:ss");
      if (nowTime < this.dailyStartTime || nowTime > this.dailyEndTime) return "DailyClosed";
      return "Open";
    },
    // 清除状态切换定时器，离开页面时避免泄漏
    clearStatusTimer() {
      if (this.statusTimer) {
        clearTimeout(this.statusTimer);
        this.statusTimer = null;
      }
    },
    // 距离下一次状态切换还有多少毫秒：开奖开始 / 当天结束 / 次日开奖 / 活动结束
    getNextStatusDelay() {
      if (!this.activityStartDate || !this.activityEndDate || !this.dailyStartTime || !this.dailyEndTime) {
        return null;
      }
      const now = this.getNowMoment();
      const status = this.computeActivityStatus();
      if (status === "Closed") return null;

      if (status === "NotStarted") {
        const start = this.parseDateTime(this.activityStartDate);
        const firstOpen = this.parseDateTime(start.format("YYYY-MM-DD") + " " + this.dailyStartTime);
        const target = firstOpen.isAfter(start) ? firstOpen : start;
        return target.valueOf() - now.valueOf();
      }

      const todayStart = this.parseDateTime(now.format("YYYY-MM-DD") + " " + this.dailyStartTime);
      const todayEnd = this.parseDateTime(now.format("YYYY-MM-DD") + " " + this.dailyEndTime);
      const endDay = this.parseDateTime(this.activityEndDate).format("YYYY-MM-DD");

      if (status === "Open") {
        return todayEnd.valueOf() - now.valueOf();
      }

      // 当天尚未到开放时间
      if (now.isBefore(todayStart)) {
        return todayStart.valueOf() - now.valueOf();
      }

      const nowDay = now.format("YYYY-MM-DD");
      // 最后一天窗口已过，等到零点变为 Closed
      if (nowDay === endDay) {
        const closedAt = this.parseDateTime(endDay + " 23:59:59").add(1, "second");
        return closedAt.valueOf() - now.valueOf();
      }

      // 当天已过开放时间，等到次日 DailyStartTime
      const tomorrowStart = this.parseDateTime(now.clone().add(1, "day").format("YYYY-MM-DD") + " " + this.dailyStartTime);
      return tomorrowStart.valueOf() - now.valueOf();
    },
    // 到点只更新本地状态，带 0~3 秒抖动，避免整点万人同时请求
    scheduleStatusTimer() {
      this.clearStatusTimer();
      const delay = this.getNextStatusDelay();
      if (delay == null) return;
      if (delay <= 0) {
        this.activityStatus = this.computeActivityStatus();
        this.statusTimer = setTimeout(() => {
          this.scheduleStatusTimer();
        }, 1000);
        return;
      }
      const jitter = Math.floor(Math.random() * 3000);
      const wait = Math.min(delay + jitter, 60 * 60 * 1000); // 最长 1 小时后再校准一次
      this.statusTimer = setTimeout(() => {
        this.activityStatus = this.computeActivityStatus();
        this.scheduleStatusTimer();
      }, wait);
    },
    // 拉取活动配置/次数/积分；转动中不请求，过期回包丢弃
    getActivityInfo() {
      if (this.spinning) return;
      const reqId = ++this.activityInfoReqId;
      GetActivityInfo().then((res) => {
        if (reqId !== this.activityInfoReqId || this.spinning) return;
        if (res.Status != 1 || !res.Data) return;
        const data = res.Data;
        this.remainCount = Number(data.RemainingDrawCount) || 0; // RemainingDrawCount：今日剩余抽奖次数
        this.pointsPerDraw = Number(data.PointsPerDraw) || 0; // PointsPerDraw：每次抽奖消耗积分
        this.currentPoints = Number(data.CurrentPoints) || 0; // CurrentPoints：当前积分数
        this.activityPrizes = data.Prizes || []; // Prizes：转盘奖品列表
        this.activityStartDate = data.StartDate || ""; // StartDate：活动开始日期
        this.activityEndDate = data.EndDate || ""; // EndDate：活动结束日期（按日期包含当天）
        this.dailyStartTime = data.DailyStartTime || ""; // DailyStartTime：每天开始抽奖时间 HH:mm:ss
        this.dailyEndTime = data.DailyEndTime || ""; // DailyEndTime：每天结束抽奖时间 HH:mm:ss
        this.applyServerTime(res.ServerTime); // ServerTime：校准本地时钟
        this.activityStatus = this.computeActivityStatus() || data.ActivityStatus || ""; // ActivityStatus：NotStarted / DailyClosed / Open / Closed
        this.activityReady = true;
        this.scheduleStatusTimer();
      });
    },
    // 点击抽奖前的前端拦截文案；空字符串表示当前可抽（最终仍以 LotteryDraw 为准）
    activityBlockMessage() {
      const messages = {
        NotStarted: "抽奖活动尚未开始",
        DailyClosed: "当前不在抽奖时间",
        Closed: "抽奖活动已结束",
      };
      const status = this.computeActivityStatus();
      if (status && status !== "Open") {
        return messages[status] || "当前无法抽奖";
      }
      return "";
    },
    prizeStyle(index) {
      const count = this.wheelPrizes.length || 1;
      return {
        transform: "rotate(" + (360 / count) * index + "deg)",
      };
    },
    getTargetDeg(prizeId) {
      const list = this.wheelPrizes;
      const index = list.findIndex((item) => item && item.PrizeId === prizeId);
      if (index < 0 || !list.length) return 0;
      const slice = 360 / list.length;
      return (360 - index * slice) % 360;
    },
    // 点击 GO：前端先拦截，通过后只调 LotteryDraw；成功用回包更新次数积分，失败再拉活动信息
    async handleGo() {
      if (this.spinning) return;
      if (!this.islogin) {
        this.toLogin();
        return;
      }
      if (!this.activityReady) {
        this.$toast({ message: "活动信息加载中" });
        return;
      }
      const blockMsg = this.activityBlockMessage();
      if (blockMsg) {
        this.$toast({ message: blockMsg });
        return;
      }
      if (Number(this.remainCount) <= 0) {
        this.$toast({ message: "今日抽奖次数已用完" });
        return;
      }
      if (this.pointsPerDraw > 0 && Number(this.currentPoints) < this.pointsPerDraw) {
        this.$toast({ message: "积分不足" });
        return;
      }
      const ready = this.startWheelAnimate();
      this.activityInfoReqId += 1; // 作废进行中的 GetActivityInfo，防止抽完被旧数据覆盖
      try {
        const res = await LotteryDraw();
        await ready;
        if (!res || res.Status != 1) {
          await this.stopWheelAnimate(0);
          this.$toast({ message: (res && res.Message) || "抽奖失败，请稍后再试" });
          this.getActivityInfo(); // 失败后对齐服务端次数/状态
          return;
        }
        const data = res.Data || {};
        this.remainCount = Number(data.RemainingDrawCount) || 0;
        this.currentPoints = Number(data.CurrentPoints) || 0;
        const prize = {
          drawId: data.DrawId,
          prizeId: data.PrizeId,
          prizeType: data.PrizeType,
          name: data.PrizeName || "",
          level: data.PrizeType === 1 ? "积分奖品" : "实物奖品",
          img: data.PrizeImageUrl || this.imgs.prize07,
        };
        await this.stopWheelAnimate(this.getTargetDeg(data.PrizeId));
        if (data.IsWin && data.PrizeType !== 0) {
          this.openWinDialog(prize);
        } else {
          this.openLoseDialog();
        }
      } catch (err) {
        if (this.spinning) await this.stopWheelAnimate(0);
        this.$toast({ message: "抽奖失败，请稍后再试" });
        this.getActivityInfo(); // 异常时同步次数和活动状态
      }
    },
    openPrizeList() {
      if (!this.islogin) {
        this.toLogin();
        return;
      }
      GetMyPrizes().then((res) => {
        if (res.Status == 1) {
          const list = Array.isArray(res.Data) ? res.Data : [];
          this.myPrizes = list.map((item) => ({
            drawId: item.DrawId,
            prizeId: item.PrizeId,
            name: item.PrizeName,
            img: item.PrizeImageUrl,
            status: item.HasShippingInfo ? "done" : "pending",
            time: item.WinTime || "",
            shipping: item.ShippingInfo || null,
          }));
        } else if (res.Message) {
          this.$toast({ message: res.Message });
        }
        this.dialogType = "list";
        this.dialogVisible = true;
      });
    },
    openWinDialog(prize) {
      if (prize) this.currentPrize = prize;
      this.prizeForm = { name: "", phone: "", address: "" };
      this.dialogType = "win";
      this.dialogVisible = true;
    },
    openLoseDialog() {
      this.dialogType = "lose";
      this.dialogVisible = true;
    },
    goToForm() {
      this.formBackTo = "win";
      this.dialogType = "form";
    },
    goToRedeem(item) {
      this.currentPrize = {
        drawId: item.drawId,
        prizeId: item.prizeId,
        prizeType: 2,
        name: item.name,
        img: item.img,
        level: "实物奖品",
      };
      const shipping = item.shipping || {};
      this.prizeForm = {
        name: shipping.Recipient || "",
        phone: shipping.Phone || "",
        address: shipping.Address || "",
      };
      this.formBackTo = "list";
      this.dialogType = "form";
    },
    backFromForm() {
      this.dialogType = this.formBackTo === "list" ? "list" : "win";
    },
    submitPrizeForm() {
      if (this.submitting) return;
      if (this.$moment().isAfter("2026-10-16 23:59:59")) {
        this.$toast({ message: "领奖信息提交已截止" });
        return;
      }
      const name = (this.prizeForm.name || "").trim();
      const phone = (this.prizeForm.phone || "").trim();
      const address = (this.prizeForm.address || "").trim();
      if (!name) {
        this.$toast({ message: "请输入姓名" });
        return;
      }
      if (!phone) {
        this.$toast({ message: "请输入手机号" });
        return;
      }
      // 手机号格式
      if (!/^1[3456789]\d{9}$/.test(phone)) {
        this.$toast({ message: "请输入正确的手机号" });
        return;
      }

      if (address.length < 5 || address.length > 300) {
        this.$toast({ message: "收件地址至少需为5个字符" });
        return;
      }
      if (!this.currentPrize.drawId) {
        this.$toast({ message: "缺少中奖记录，请刷新后重试" });
        return;
      }
      this.submitting = true;
      SaveShippingInfo({
        DrawId: this.currentPrize.drawId,
        Recipient: name,
        Phone: phone,
        Address: address,
      }).then((res) => {
        if (res.Status == 1) {
          this.dialogType = "success";
          this.myPrizes = this.myPrizes.map((item) => {
            if (item.drawId && item.drawId === this.currentPrize.drawId) {
              return {
                ...item,
                status: "done",
                shipping: { Recipient: name, Phone: phone, Address: address },
              };
            }
            return item;
          });
        } else {
          this.$toast({ message: res.Message || "提交失败，请稍后再试" });
        }
      }).finally(() => {
        this.submitting = false;
      });
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    // 抽奖开始：转盘由慢到快，到达最高速后保持匀速
    startWheelAnimate() {
      return new Promise((resolve) => {
        if (this.spinning) {
          if (this.wheelPhase === "cruise") {
            resolve();
            return;
          }
          this.wheelStartResolve = resolve;
          return;
        }
        this.spinning = true;
        this.wheelPhase = "accelerate";
        this.wheelSpeed = this.wheelMinSpeed;
        this.wheelAccelElapsed = 0;
        this.wheelLastTs = 0;
        this.wheelStartResolve = resolve;
        this._tickWheel();
      });
    },
    // 抽奖结束：转盘由快到慢，停在 targetDeg（指针正上方对应的角度）
    stopWheelAnimate(targetDeg = 0) {
      return new Promise((resolve) => {
        if (!this.spinning) {
          resolve();
          return;
        }
        if (this.wheelPhase === "decelerate") {
          this.wheelStopResolve = resolve;
          return;
        }
        this.wheelStopResolve = resolve;
        this.wheelPhase = "decelerate";
        this.wheelDecelElapsed = 0;
        this.wheelDecelStartDeg = this.rotateDeg;
        const speed = Math.max(this.wheelSpeed, this.wheelMinSpeed);
        const idealDistance = (speed * this.wheelDecelTime) / 1000 / 3;
        const currentMod = ((this.rotateDeg % 360) + 360) % 360;
        const targetMod = ((targetDeg % 360) + 360) % 360;
        const remain = (targetMod - currentMod + 360) % 360;
        let turns = Math.round((idealDistance - remain) / 360);
        if (turns < 3) turns = 3;
        this.wheelDecelDistance = turns * 360 + remain;
      });
    },
    _tickWheel(ts) {
      this.wheelRaf = requestAnimationFrame((nextTs) => this._tickWheel(nextTs));
      if (!ts) return;
      if (!this.wheelLastTs) {
        this.wheelLastTs = ts;
        return;
      }
      const dt = Math.min(ts - this.wheelLastTs, 50);
      this.wheelLastTs = ts;

      if (this.wheelPhase === "accelerate") {
        this.wheelAccelElapsed += dt;
        const t = Math.min(this.wheelAccelElapsed / this.wheelAccelTime, 1);
        const eased = t * t;
        this.wheelSpeed = this.wheelMinSpeed + (this.wheelMaxSpeed - this.wheelMinSpeed) * eased;
        this.rotateDeg += (this.wheelSpeed * dt) / 1000;
        if (t >= 1) {
          this.wheelPhase = "cruise";
          this.wheelSpeed = this.wheelMaxSpeed;
          if (this.wheelStartResolve) {
            this.wheelStartResolve();
            this.wheelStartResolve = null;
          }
        }
      } else if (this.wheelPhase === "cruise") {
        this.rotateDeg += (this.wheelMaxSpeed * dt) / 1000;
      } else if (this.wheelPhase === "decelerate") {
        this.wheelDecelElapsed += dt;
        const t = Math.min(this.wheelDecelElapsed / this.wheelDecelTime, 1);
        const eased = 1 - Math.pow(1 - t, 3);
        this.rotateDeg = this.wheelDecelStartDeg + this.wheelDecelDistance * eased;
        this.wheelSpeed = ((3 * Math.pow(1 - t, 2)) * this.wheelDecelDistance) / (this.wheelDecelTime / 1000);
        if (t >= 1) {
          this._finishWheel();
        }
      }
    },
    _finishWheel() {
      if (this.wheelRaf) {
        cancelAnimationFrame(this.wheelRaf);
        this.wheelRaf = null;
      }
      this.spinning = false;
      this.wheelPhase = "idle";
      this.wheelSpeed = 0;
      this.wheelLastTs = 0;
      if (this.wheelStartResolve) {
        this.wheelStartResolve();
        this.wheelStartResolve = null;
      }
      if (this.wheelStopResolve) {
        this.wheelStopResolve();
        this.wheelStopResolve = null;
      }
    },
  },
  // 离开抽奖页：去掉前台监听和状态定时器
  beforeDestroy() {
    document.removeEventListener("visibilitychange", this.onVisibilityChange);
    this.clearStatusTimer();
    this._finishWheel();
  },
  computed: {
    // 抽奖活动奖品列表
    wheelPrizes() {
      const list = Array.isArray(this.activityPrizes) ? this.activityPrizes.slice() : [];
      const hasSort = list.some((item) => item && item.Sort !== undefined && item.Sort !== null && item.Sort !== "");
      if (hasSort) {
        list.sort((a, b) => Number(a.Sort) - Number(b.Sort));
      }
      return list;
    },
    clientWidth() {
      return this.$store.state.clientWidth;
    },
    userInfo() {
      return this.$store.state.userInfo;
    },
    islogin() {
      return this.$store.state.islogin;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
